var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('NcContent',{attrs:{"app-name":"settings"}},[_c('UserManagementNavigation'),_vm._v(" "),_c('NcAppContent',{attrs:{"page-heading":_vm.pageHeading}},[_c('UserList',{attrs:{"selected-group":_vm.selectedGroupDecoded,"external-actions":_vm.externalActions}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }